import Vue from 'vue';
import { post, get, geoJson } from './requset';
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$geoJson = geoJson;
